import { render, staticRenderFns } from "./back-heading-button.vue?vue&type=template&id=34a7b490&lang=pug&"
import script from "./back-heading-button.vue?vue&type=script&lang=js&"
export * from "./back-heading-button.vue?vue&type=script&lang=js&"
import style0 from "./back-heading-button.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports